module.exports = __webpack_public_path__ + "static/media/kanzas.25c36d08.webp";